interface CTAWidgetProps {
  title?: string
  description?: string
  buttonText?: string
  onButtonClick?: () => void
}

export function CTAWidget({ 
  title = 'Go Premium',
  description = 'Unlock all games, archives, and ad-free experience',
  buttonText = 'Upgrade to Premium',
  onButtonClick
}: CTAWidgetProps) {
  return (
    <div className="bg-gradient-to-br from-[#1a1a1a] to-[#2c2c2c] text-white rounded-2xl p-8 text-center">
      <h2 className="font-bebas-neue text-3xl md:text-4xl font-medium tracking-[2px] uppercase mb-2">
        {title}
      </h2>
      <p className="font-oswald text-sm font-medium uppercase tracking-[0.5px] opacity-90 mb-5">
        {description}
      </p>
      <button 
        onClick={onButtonClick}
        className="bg-white text-[#1a1a1a] rounded-lg px-10 py-3.5 font-oswald text-lg font-bold uppercase tracking-[1.5px] transition-all hover:-translate-y-px hover:shadow-lg hover:shadow-white/20"
      >
        {buttonText}
      </button>
    </div>
  )
}